import { useTranslation } from 'react-i18next';
import { SUPPORTED_LANGUAGES } from 'i18n';
import { IconDropdown } from './IconDropdown';

export const LanguageSwitcher = () => {
  const { t, i18n } = useTranslation();

  return (
    <IconDropdown
      triggerIcon="translate"
      triggerTitle={t('THEME.CHANGE_LANGUAGE')}
      options={SUPPORTED_LANGUAGES.map((language) => ({ key: language.code, label: language.label }))}
      activeKey={i18n.language}
      onSelect={(code) => i18n.changeLanguage(code)}
    />
  );
};
